import t from 'rcm-i18n';
import React from 'react';

interface Props {
    resultCount: number;
    searchDescription: string;
}

const ResultsDescription = ({ resultCount, searchDescription }: Props) => {
    return <div className="all-products-search-description">
        {t('{resultCount} results for "{searchDescription}"', { resultCount, searchDescription: t(searchDescription) })}
    </div>
};

export default ResultsDescription;
